<template>
  <div id="app" @click.stop="isTimeOut">
    <el-scrollbar class="page-scroll"
      :style="isMobileState() ? 'width: 1500px;height: 100%' : 'width: 100%;height: 100%'"
      :class="isWidthState() ? 'pageWidth' : ''">
      <router-view v-if="isReload" />
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload
    }
  },

  data() {
    return {
      timeOut: '',
      bAntiShike: false,
      isReload: true,
      isMobile:false,
    };
  },
  created() {
    this.isTimeOut();
  },
  mounted() {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      /*window.location.href="你的手机版地址";*/
      this.isMobile = true;
    } else {
      /*window.location.href="你的电脑版地址";    */
      this.isMobile = false;
    }
    this.$store.commit('isMobile', this.isMobile);
    localStorage.setItem('isMobile', this.isMobile);
    // window.onresize = () => {
    //   if (!this.bAntiShike) {
    //     this.bAntiShike = true ;
    //     console.log(document.documentElement.clientWidth,'document.documentElement.clientWidth')
    //     setTimeout(() => {
    //       if(document.documentElement.clientWidth<1440){
    //           // var bodyWidth = this.setBodyWidth()+"px" ;
    //           // doucumnet.body.style.width = bodyWidth ;
    //           if(document.documentElement.clientWidth<860){
    //             this.$message.warning('当前窗口太小,不利于观看,请放大后操作。')
    //           }
    //       }
    //       this.bAntiShike = false
    //     }, 300)
    //   }
    // }

    // 监听浏览器刷新
    // let that = this ;
    // console.log("浏览器刷新 || 关闭了5555");
    // window.addEventListener( "unload", that.browerStatus() );
  },
  destroyed() {
    window.removeEventListener('unload', this.browerStatus())
  },
  methods: {
    isMobileState() {
      console.log("获取数据",this.isMobile)
      if (this.isMobile) {
        let path = this.$route.path;
        console.log("路由", path);
        if (
          path !== "/" &&
          path !== "/login" &&
          path !== "/goRegister" &&
          path !== "/wxLogin" &&
          path !== "/wxRegister"
        ) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    isWidthState() {
      if (!this.isMobile) {
        let path = this.$route.path;
        if (
          path !== "/" &&
          path !== "/login" &&
          path !== "/goRegister" &&
          path !== "/wxLogin" &&
          path !== "/wxRegister"
        ) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    browerStatus() {
      console.log("浏览器刷新 || 关闭了");
      this.getMenuAjax();
    },
    getMenuAjax() {
      let _this = this;
      // console.log(localStorage.getItem('hotelData'),'99999')
      let roleId = localStorage.getItem('hotelData') ? JSON.parse(localStorage.getItem('hotelData')).staffRoleId : "";
      // localStorage.setItem('staffRoleId',row.staffRoleId) ;
      console.log(roleId, '---roleId----')
      if (!roleId) {
        return;
      }
      let params = {
        mType: 1,
        roleId: roleId
      };
      let url = "webapi/menu/list";
      _this.postRequest(url, params,
        function (data) {
          if (data.code === 0) {
            if (data.data.authMenuList.length) {
              localStorage.setItem('authority', JSON.stringify(data.data.authMenuList));
              _this.firstLevelIndex(data.data.authMenuList);
            }
          }

        }, 1
      );
    },
    // 获取当前下标
    firstLevelIndex(authority) {
      let submenu = [];
      authority.map(val => {
        if (val.submenu.length) {
          val.submenu.map((res, ind) => {
            if (res.submenu.length) {
              let path = res.submenu[0].path;
              submenu.push(path);
            }

          })
        }

      })
      console.log(submenu, '---submenu----')
      if (submenu.length && submenu[0]) {
        this.$router.push({ path: submenu[0] });
      }



    },
    reload() {
      this.isReload = false
      this.$nextTick(() => {
        this.isReload = true
      })
    },
    setBodyWidth() {
      var barWidthHelper = document.createElement('div');
      barWidthHelper.style.cssText = "overflow:scroll; width:100px; height:100px;";
      document.body.appendChild(barWidthHelper);
      var barWidth = barWidthHelper.offsetWidth - barWidthHelper.clientWidth;
      document.body.removeChild(barWidthHelper);
      var bodyWidth = window.screen.availWidth - barWidth;
      return bodyWidth;
    },
    throttle(fn, wait) {
      // 节流throttle代码(时间戳+定时器) 
      var timer = null; // 定义一个变量来 储存定时器 
      var startTime = Date.now(); // 存开始时间
      return function () {
        var curTime = Date.now(); // 存现在时间 
        var remaining = wait - (curTime - startTime);
        var context = this;
        var args = arguments;
        clearTimeout(timer);
        if (remaining <= 0) {
          fn.apply(context, args);
          startTime = Date.now();
        } else {
          timer = setTimeout(fn, remaining);
        }
      }
    },
    handle() {
      localStorage.removeItem("backFlag")
      clearInterval(this.timeOut); // console.log(Math.random()); log.info('========>','我清除了吗？') 
      if (this.$route.path == '/login' || this.$route.path == '/wxLogin') {
        return;
      } else {
        this.timeOut = setInterval(() => {
          console.log('this.$route.path', this.$route.path)
          this.$router.go(0);
          return clearInterval(this.timeOut);
        }, 1000 * 1800)
      }

    },
    isTimeOut() {
      document.body.onmouseup = this.throttle(this.handle, 1000);
      document.body.onmousemove = this.throttle(this.handle, 1000);
      document.body.onkeyup = this.throttle(this.handle, 1000);
      document.body.onclick = this.throttle(this.handle, 1000);
      document.body.ontouchend = this.throttle(this.handle, 1000);
      window.addEventListener('resize', this.throttle(this.handle, 1000));
      window.addEventListener('scroll', this.throttle(this.handle, 1000));
    }

  }
}
</script>

<style>
.pageWidth {
  min-width: 1500px;
}

@media (max-width: 768px) {
  .pageWidth {
    min-width: auto;
    /* 移除最小宽度限制 */
    width: 100%;
    /* 让页面宽度自适应屏幕 */
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue